var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"href":_vm.href,"rel":"noreferrer noopener","small":"","target":"_blank","text":""}},[_vm._t("default"),(_vm.icon)?_c('v-icon',{attrs:{"right":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }